export default __webpack_public_path__ + "static/media/ic_notification_shipping.6e3f6f04.svg";